import React, {useState, useEffect} from "react";
import { getStudent, updatePupilPeriod, updateRoadmapProgress} from "../../services/scpApi";
import BundleProgress from "../../features/bundleProgress/BundleProgress";
import { fetchStudent } from "../../slices/portalSelectedSlice.js";
import { useDispatch, useSelector } from "react-redux";
import Roadmap from "../../features/roadmap/Roadmap";


const UpdateStudentProgress = () => {

    const [student, setStudent] = useState({});
    const [currentPeriod, setCurrentPeriod] = useState();
    const [currentBundleProgress, setCurrentBundleProgress] = useState({});
    const [roadmap, setRoadmap] = useState([]);
    const [upcomingRoadmap, setUpcomingRoadmap] = useState([]);
    const [bundleData, setBundleData] = useState({});
    const [loading, setLoading] = useState(null);
    const [error, setError] = useState('');
    const selectedStudent = useSelector(state => state.portalSelected.selectedStudent);
    const selectedSchool = useSelector(state => state.portalSelected.selectedSchool);
    const user = useSelector((state) => state.auth.authUser);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!selectedStudent || !selectedStudent.id) {
            setStudent({});
            setCurrentPeriod(undefined);
            setRoadmap([]);
            return;
        }

        setStudent(selectedStudent);
        const latestPeriod = selectedStudent.pupil_periods ? selectedStudent.pupil_periods[selectedStudent.pupil_periods.length - 1] : undefined;
        setCurrentPeriod(latestPeriod);
        const latestBundleProgress = latestPeriod?.bundle_progress || {};
        setCurrentBundleProgress(latestBundleProgress);

        refreshRoadmap();
    }, [selectedStudent])

    const refreshRoadmap = async () => {
        // sort the roadmap response to be sorted inline with the order property
        if (!selectedStudent.roadmap) {
            setRoadmap([]);
            setUpcomingRoadmap([]);
            return;
        }
        
        const sortedUpcomingRoadmap = [...(selectedStudent?.roadmap?.upcoming || [])];
        
        if (sortedUpcomingRoadmap && sortedUpcomingRoadmap.length > 0) {
            sortedUpcomingRoadmap.sort((a, b) => {
                return a.order - b.order;
            });
        }

        const fullRoadmap = {...selectedStudent.roadmap};
    
        if (fullRoadmap) {
            fullRoadmap.upcoming = sortedUpcomingRoadmap;
        }

        setRoadmap(fullRoadmap || []);
        setUpcomingRoadmap(sortedUpcomingRoadmap || []);
    }

    const refetchStudentData = async () => {
        if (!selectedStudent?.id) {
            return;
        }

        dispatch(fetchStudent(selectedStudent.id));
    };

    useEffect(() => {
        // get the last period for the pupil
        if (student.pupil_periods) {
            let lastPeriod = student.pupil_periods[student.pupil_periods.length - 1];
            setCurrentPeriod(lastPeriod);
        }

        const savedRoadmapObj = student.roadmap || {};

        // Convert “upcoming” into [ { levelKey, bundleKey } ]
        const upcoming = (savedRoadmapObj.upcoming || []).map(item => ({
            levelKey:  item.level,
            bundleKey: item.bundle_key,
            order: item.order,
            lessons: item.lessons || {}
        }));

        console.log('upcoming roadmap', upcoming);
        setUpcomingRoadmap(upcoming);
    }, [student])
 

    /**
     * Update bundle status server side
     * 
     * @param {object} newBundleProgress
     */
    const updateBundleStatus = (newBundleProgress) => {
        console.log('Selected student in update progress', selectedStudent);
        console.log('Selected student at update time', selectedStudent, currentPeriod);

        // collate lessons from roadmap into bundle progress object
        roadmap?.in_progress?.forEach(item => {
            if (newBundleProgress[item.level] && newBundleProgress[item.level][item.bundle_key]) {
                newBundleProgress[item.level][item.bundle_key]['lessons'] = item.lessons;
            }
        });

        roadmap?.upcoming?.forEach((item, i) => {
            if (newBundleProgress[item.level] && newBundleProgress[item.level][item.bundle_key]) {
                newBundleProgress[item.level][item.bundle_key]['lessons'] = item.lessons;
            }
        });

        console.log('Roadmap at update time', roadmap);
        console.log('Upcomging roadmap at update time', upcomingRoadmap);
        console.log('Bundles progress at update time', newBundleProgress);
        //return;

        setError('');

        if (!student || !student.id || !currentPeriod.tutor_group?.id || !currentPeriod.year_group || !currentPeriod.pupil_status) { 
            console.log(student.id);
            console.log('missing data to update pupil period');
            return;
        }

        console.log('updating bundle progress');

        (async () => {
            setLoading('loading');

            try {
                // Collate the new roadmap
                let roadmapPayload = [];

                if (upcomingRoadmap.length > 0) {
                    roadmapPayload = upcomingRoadmap.map(({ levelKey, bundleKey }, i) => ({
                        level:      parseInt(levelKey.replace('level-', ''), 10),
                        bundle_key: bundleKey,
                        order:      i + 1,
                        outcome:    'upcoming',
                        lessons:    {}
                    }));
                }

                // Update pupil period
                let updatedPupilData = await updatePupilPeriod({
                    studentId: student.id,
                    tutorGroupId: currentPeriod.tutor_group.id,
                    yearGroup: currentPeriod.year_group,
                    pupilStatus: currentPeriod.pupil_status,
                    attendance: currentPeriod.attendance,
                    bundleProgress: newBundleProgress,
                    roadmap: roadmapPayload
                });

                if (!updatedPupilData || updatedPupilData.data?.error) {
                    throw new Error('Failed to update roadmap progress: ' + updatedPupilData.data.error);
                }

                await setStudent(updatedPupilData);
                refetchStudentData();

                setLoading('success');
                setTimeout(() => {
                  setLoading(null);
                }, 3000);
            } catch (error) {
                console.log(error);
                setLoading('error');
                setError(error);
            }
        })();
    }


    /**
     * Update lesson status in the roadmap
     * - This is for the display in the roadmap, and is mapped into the bundle progress for updating at update time
     * 
     * @param {*} levelKey 
     * @param {*} bundleKey 
     * @param {*} lessonNum 
     * @returns 
     */
    const updateLessonStatus = (levelKey, bundleKey, lessonNum) => {

        // front-end authorisation (only super-admins can update lesson status)
        if (user?.user_role !== 'super_admin') {
            console.error('Only super-admins can update lesson status');
            return;
        }

        // update lessons in roadmap (in progress and upcoming only)
        console.log('Updating lesson status for:', levelKey, bundleKey, lessonNum, roadmap);

        setRoadmap(prevRoadmap => ({
            ...prevRoadmap,
            in_progress: prevRoadmap.in_progress.map(item =>
                item.level === levelKey && item.bundle_key === bundleKey
                    ? {
                        ...item,
                        lessons: {
                            ...item.lessons,
                            [lessonNum]: !item.lessons[lessonNum],
                        },
                    }
                    : item
            ),
            upcoming: prevRoadmap.upcoming.map(item =>
                item.level === levelKey && item.bundle_key === bundleKey
                    ? {
                        ...item,
                        lessons: {
                            ...item.lessons,
                            [lessonNum]: !item.lessons[lessonNum],
                        },
                    }
                    : item
            ),
        }));
    };


    return (
        <div className="update-student-progress">
            {student && currentPeriod &&
                <>
                    <Roadmap
                        student={student}
                        roadmap={roadmap}
                        setRoadmap={setRoadmap}
                        updateLessonStatus={updateLessonStatus}
                    />

                    <p className="instruction">Click to update the bundle status (complete / in progress)</p>

                    <BundleProgress 
                        currentBundleProgress={currentBundleProgress} 
                        updateBundleProgress={(newBundleProgress) => updateBundleStatus(newBundleProgress)} 
                        loading={loading}
                        roadmap={upcomingRoadmap}
                        setRoadmap={setUpcomingRoadmap}
                        refetchStudentData={refetchStudentData}
                        bundleData={bundleData}
                        setBundleData={setBundleData}
                    />

                    <div className="validation-errors">
                        {loading === 'success' && 'Bundle progress updated successfully'}
                        {loading === 'error' && 'Error updating bundle progress: ' + error.message}
                    </div>  
                </>
            }
        </div>
    );
}

export default UpdateStudentProgress;
